import { getCurrentInstance } from 'vue'
import { Framework } from 'vuetify'

/** $vuetify da instância atual (breakpoint, application, theme...) */
export function useVuetify(): Framework {
	const instancia = getCurrentInstance()
	if (!instancia) throw new Error('useVuetify() só pode ser usado dentro do setup()')
	return instancia.proxy.$vuetify
}
